import React, { useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import { useMsal } from '@azure/msal-react';
import { useHistory } from 'react-router-dom';
import { setAuthToken, setIdToken, getApplyAgentIssuanceOnly } from '../../helpers/localStorage';
import { crownSsoLoginAPI } from '../../services/api';

import Loader from '../../components/loader';
import logo from '../../assets/images/tcn-logo.svg';
import Footer from '../../components/Footer';
import Notify from '../../components/notify';
import './Login.scss';

export default function SignIn() {
  const [openSuccessNotify, setOpenSuccessNotify] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { instance, accounts } = useMsal();
  const history = useHistory();

  useEffect(() => {
    if (accounts?.length > 0) {
      setLoading(true);
      loginCrownUser();
    }
  }, [accounts]);

  const initializeSignIn = async () => {
    setLoading(true);
    await instance.loginRedirect({
      scopes: ["user.read"] // optional Array<string>
    });
  };

  const loginCrownUser = async () => {
    const accountInfo = accounts[0] || null;

    if (accountInfo) {
      await instance.initialize();
      let tokenResult = await instance.acquireTokenSilent({
        scopes: ["user.read"],
        account: accountInfo
      });

      if (tokenResult) {
        try {
          const res = await crownSsoLoginAPI(tokenResult.idToken)
          setAuthToken(res.auth_token);
          setIdToken(res.id_token);
          await getApplyAgentIssuanceOnly()
            ? history.push('/agent-issuance')
            : history.push('/dashboard');
        } catch (err) {
          setErrors(err);
          setLoading(false);
          setOpenSuccessNotify(true);
        }
      }
    }
  };

  return (
    <>
      <Container component="main" className="login-crown-container flex-col container">
        <CssBaseline />
        <div className="login-crown-body flex flex-col items-center">
          <Avatar className="avatar">
            <img src={logo} alt="login-logo"></img>
          </Avatar>
          <Button
            type="submit"
            fullWidth
            className="submit-btn"
            onClick={initializeSignIn}
            disabled={loading}
            endIcon={
              <ArrowForwardOutlinedIcon style={{ color: '#FFFB00' }} />
            }
          >
            Sign In
          </Button>
        </div>

      </Container>
      <Footer />
      <Notify
        open={openSuccessNotify}
        onClose={() => setOpenSuccessNotify(false)}
        errors={errors}
      />
      <Loader loading={loading} />

    </>
  );
}